    <h3>Are you sure?</h3>
    <div class="card-body ">
        <h4>There are still items in your bundle, stay and save your changes!
        </h4>
    </div>
    <div class="row align-items-center">
        <div class="col-6">
            <button class="btn
                        btn-primary btn-block" (click)="stay()">
                Stay
            </button>
        </div>
    </div>
